module.exports = __webpack_public_path__ + "ca2d29cdbd2853140037bacf9a30a315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipements/aluminium.png
// module id = FNLs
// module chunks = 0